import PropTypes from 'prop-types';

const assessmentSettingsPropType = PropTypes.shape({
    pollId: PropTypes.string.isRequired,
    assessmentOwner: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    hide: PropTypes.bool,
    retire: PropTypes.bool,
    retireDate: PropTypes.string,
    assessmentType: PropTypes.number,
    needByDate: PropTypes.string,
    therapyStartDate: PropTypes.string,
    summaryNote: PropTypes.string,
    requireSummaryNote: PropTypes.bool,
    enhancedSummaryNote: PropTypes.bool,
    ehrEncounterNote: PropTypes.bool,
    requireMedicationAssociation: PropTypes.bool,
    generalSpecialty: PropTypes.bool,
    referralActivityForVista: PropTypes.bool,
    mobileEnabled: PropTypes.bool,
    mobileAssessmentTextMessage: PropTypes.string,
});

export default assessmentSettingsPropType;
